import * as angular from "angular";
import {BringozToastService} from "./bringoz-toast.service";


export class CommonsAlertsService {
  constructor(private bringozToastService: BringozToastService, private $filter) {
  }

  // SEND SMS //
  sendSMSSuccess() {
    let message = {
      body: 'COMMONS_SEND_SMS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  sendSMSError() {
    let message = {
      body: 'COMMONS_SEND_SMS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT TO MAIL //
  exportToMailSuccess() {
    let message = {
      body: 'COMMONS_EXPORT_TO_MAIL_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportToMailError() {
    let message = {
      body: 'COMMONS_EXPORT_TO_MAIL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DECLINE SERVICES //
  declineServicesSuccess() {
    let message = {
      body: 'COMMONS_DECLINE_SERVICES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  declineServicesError() {
    let message = {
      body: 'COMMONS_DECLINE_SERVICES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SOMETHING WENT WRONG //
  somethingWentWrongError() {
    let message = {
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // PREFERENCES //
  preferencesSuccess() {
    let message = {
      body: 'COMMONS_PREFERENCES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  preferencesError() {
    let message = {
      body: 'COMMONS_PREFERENCES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // PREFERENCES BY NAME//
  preferencesByNameSuccess(name) {
    let message = {
      body: 'X_COMMONS_PREFERENCES_BY_NAME_SUCCESS'
    };
    if (name) {
      name = this.$filter('translate')(name);
    }
    return this.bringozToastService.success(message, {name: name})
  }

  // PREFERENCES UPDATE//
  preferencesUpdateSuccess() {
    let message = {
      body: 'X_COMMONS_PREFERENCES_BY_NAME_SUCCESS'
    };
    return this.bringozToastService.success(message);
  }

  // FORM RESET //
  formResetSuccess() {
    let message = {
      body: 'COMMONS_FORM_RESET_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // FORM INVALID //
  formInvalidInfo() {
    let message = {
      body: 'COMMONS_FORM_INVALID_INFO',
      details: 'COMMONS_FORM_INVALID_INFO_DETAILS'
    };
    return this.bringozToastService.info(message)
  }

  // NOTIFICATION UPDATE //
  notificationUpdateSuccess() {
    let message = {
      body: 'COMMONS_NOTIFICATION_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  notificationUpdateError() {
    let message = {
      body: 'COMMONS_NOTIFICATION_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // NOTIFICATION RESET //
  notificationResetSuccess() {
    let message = {
      body: 'COMMONS_NOTIFICATION_RESET_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  notificationResetError() {
    let message = {
      body: 'COMMONS_NOTIFICATION_RESET_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RESET PASSWORD //
  resetPasswordSuccess() {
    let message = {
      body: 'COMMONS_RESET_PASSWORD_SUCCESS'
    };
    return this.bringozToastService.success(message, null, 'Login')
  }

  resetPasswordError() {
    let message = {
      body: 'COMMONS_RESET_PASSWORD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  fileSizeError() {
    let message = {
      body: 'COMMONS_FILE_SIZE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE ADDRESS //
  createAddressSuccess() {
    let message = {
      body: 'COMMONS_CREATE_ADDRESS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createAddressError() {
    let message = {
      body: 'COMMONS_CREATE_ADDRESS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE ADDRESS //
  updateAddressSuccess(address) {
    let message = {
      body: 'X_COMMONS_UPDATE_ADDRESS_SUCCESS'
    };
    return this.bringozToastService.success(message, address)
  }

  updateAddressError() {
    let message = {
      body: 'COMMONS_UPDATE_ADDRESS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE ADDRESS //
  deleteAddressSuccess(address) {
    let message = {
      body: 'X_COMMONS_DELETE_ADDRESS_SUCCESS'
    };
    return this.bringozToastService.success(message, address)
  }

  deleteAddressError() {
    let message = {
      body: 'COMMONS_DELETE_ADDRESS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // PAY SELECTED //
  paySelectedSuccess() {
    let message = {
      body: 'COMMONS_PAY_SELECTED_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // Print //
  printSuccess(address?) {
    let message = {
      body: 'COMMONS_PRINT_SUCCESS'
    };
    return this.bringozToastService.success(message, address)
  }

  printError() {
    let message = {
      body: 'COMMONS_PRINT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  fileFormatError() {
    const message = {
      body: 'COMMONS_FILE_END_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // INVALID_JSON //
  invalidJsonError() {
    var message = {
      body: 'COMMONS_INVALID_JSON_ERROR'
    };
    return this.bringozToastService.info(message)
  }


  // INVALID //
  invalidSelectionInfo() {
    var message = {
      body: 'COMMONS_INVALID_SELECTION_INFO'
    };
    return this.bringozToastService.info(message)
  }

  // UPDATE_JSON //
  updateJsonMismatchError() {
    var message = {
      body: 'COMMONS_UPDATE_JSON_MISMATCH_ERROR'
    };
    return this.bringozToastService.info(message)
  }

  // Update Meta Data
  updateMetaDataSuccess() {
    const message = {
      body: 'UPDATE_META_DATA_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateMetaDataError() {
    const message = {
      body: 'UPDATE_META_DATA_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // Update Missing Items
  updateMissingItemsSuccess() {
    const message = {
      body: 'UPDATE_MISSING_ITEMS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateMissingItemsError() {
    const message = {
      body: 'UPDATE_MISSING_ITEMS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.commons')
  .service('commonsAlertsService', CommonsAlertsService);
